import { render, staticRenderFns } from "./rules.vue?vue&type=template&id=381bbc73&"
import script from "./rules.vue?vue&type=script&lang=js&"
export * from "./rules.vue?vue&type=script&lang=js&"
import style0 from "./rules.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports